export const buildAbortableQueryContext = (signal?: AbortSignal) => ({
  // Disables Apollo's global queryDeduplication for these paginated DoBox
  // fetches: two in-flight calls can share identical variables (e.g. a
  // repeated same-page fetch), and without this, aborting one controller
  // would abort the deduped network request shared by the other.
  queryDeduplication: false,
  fetchOptions: signal ? { signal } : undefined,
});
